<mat-sidenav-container class="sidenav-container" autosize>
  <!-- Middle Page -->
  <mat-sidenav-content class="middle-page">
    <!-- Svgs -->
    <!-- <div class="svg-container">
      <svg preserveAspectRatio="none" class="svg-1" viewBox="0 0 400 300">
        <path d="M0 0 L0 200 C 150 250 200 120 400 150 L400 0 L0 0" />
      </svg>
      <svg preserveAspectRatio="none" class="svg-2" viewBox="0 0 400 300">
        <path d="M0 0 L0 200 C 150 200 200 120 400 200 L400 0 L0 0" />
      </svg>
    </div> -->

    <!-- Main Content -->
    <div class="outlet-padding">
      <ng-content select="[mainContent]"></ng-content>
      <!-- <ng-container *ngTemplateOutlet="mainContent"></ng-container> -->
    </div>
  </mat-sidenav-content>

  <!-- Left Sidenav -->
  <mat-sidenav
    [opened]="true"
    class="left-sidenav"
    #linksSidenav="matSidenav"
    autoFocus="false"
    fixedInViewport="true"
    [mode]="linksSidenavMode"
    [disableClose]="true"
  >
    <ng-content select="[leftSidenav]"></ng-content>
    <!-- <ng-container *ngTemplateOutlet="leftSidenav"></ng-container> -->
  </mat-sidenav>
</mat-sidenav-container>
